"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "transformerHeader", {
    enumerable: true,
    get: function() {
        return transformerHeader;
    }
});
var _isEmpty = /*#__PURE__*/ _interop_require_default(require("lodash/isEmpty"));
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var transformerHeader = function(transformerFelt) {
    return function(spraakNoekkel) {
        return function(header, data, korttype) {
            var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
            if (!header) {
                return undefined;
            }
            if (header.type === "id") {
                var _header_transformer;
                if ((_header_transformer = header.transformer) === null || _header_transformer === void 0 ? void 0 : _header_transformer.referanser) {
                    var referanse = header.transformer.referanser[0];
                    var id = spraakNoekkel(korttype.id) + "." + data[referanse];
                    return options.intl.formatMessage({
                        id: id
                    });
                }
                var id1 = spraakNoekkel(korttype.id);
                return options.intl.formatMessage({
                    id: id1
                });
            }
            if (header.type === "kodeliste" && header.transformer) {
                var feltData = data ? data[header.transformer.tilhoerendeReferanse] : data;
                return transformerFelt(header, feltData, _object_spread({
                    returnerDataOnMissingTransformer: false
                }, options));
            }
            if (header.transformer) {
                var transformerOptions = _object_spread({
                    returnerDataOnMissingTransformer: false
                }, options);
                if (header.transformer.referanser && Array.isArray(korttype.barnliste) && !options.transformerReferanserFelt) {
                    // Legger med feltdefinisjon for referansene slik at eventuelle felttransformere benyttes
                    var transformerReferanserFelt = Object.fromEntries(header.transformer.referanser.map(function(feltRef) {
                        return [
                            feltRef,
                            korttype.barnliste.find(function(feltDef) {
                                return feltDef.referanse === feltRef;
                            })
                        ];
                    }).filter(function(param) {
                        var _param = _sliced_to_array(param, 2), _ = _param[0], feltDef = _param[1];
                        return !!feltDef;
                    }));
                    if (!(0, _isEmpty.default)(transformerReferanserFelt)) {
                        transformerOptions.transformerReferanserFelt = transformerReferanserFelt;
                    }
                }
                return transformerFelt(header, data, transformerOptions);
            }
            return undefined;
        };
    };
};
